import type { VoucherForCampaignListByHotelIdQuery } from "@/lib/gql/__generated__/graphql";

import { useCampaignDelete } from "../../repository/mutation/use-campaign-delete/use-campaign-delete";
import { useNavigateToCampaignPage } from "../use-navigate/use-navigate";

type Props = {
	hotelID: string;
	data: VoucherForCampaignListByHotelIdQuery;
};

export const useInitialize = ({ hotelID, data }: Props) => {
	return {
		voucherForCampaignList: data.voucherForCampaignListByHotelID.voucherForCampaignList,
		...useNavigateToCampaignPage({ hotelID }),
		...useCampaignDelete({ hotelID }),
	};
};
